import { Plus } from 'lucide-react';
import { Button } from '@/ui/components/ui/button';
import { cn } from '@/ui/lib/utils';
import type { SortBy } from '../utils/feature.utils';

interface FeatureToolbarProps {
	sortBy: SortBy;
	formOpen: boolean;
	onSortChange: (sort: SortBy) => void;
	onToggleForm: () => void;
}

export function FeatureToolbar({
	sortBy,
	formOpen,
	onSortChange,
	onToggleForm,
}: FeatureToolbarProps) {
	return (
		<div className='flex items-center justify-between mb-4'>
			<div className='flex gap-1'>
				<Button
					type='button'
					variant={sortBy === 'votes' ? 'secondary' : 'ghost'}
					size='sm'
					className={cn(
						'rounded-full text-sm cursor-pointer',
						sortBy === 'votes'
							? 'text-primary font-medium hover:bg-secondary hover:text-primary'
							: 'text-muted-foreground font-normal hover:bg-transparent hover:text-current',
					)}
					onClick={() => onSortChange('votes')}
				>
					Top votes
				</Button>
				<Button
					type='button'
					variant={sortBy === 'newest' ? 'secondary' : 'ghost'}
					size='sm'
					className={cn(
						'rounded-full text-sm cursor-pointer',
						sortBy === 'newest'
							? 'text-primary font-medium hover:bg-secondary hover:text-primary'
							: 'text-muted-foreground font-normal hover:bg-transparent hover:text-current',
					)}
					onClick={() => onSortChange('newest')}
				>
					Newest
				</Button>
			</div>

			<Button
				type='button'
				variant={formOpen ? 'ghost' : 'default'}
				size='sm'
				className={cn(
					'rounded-full text-sm font-semibold',
					formOpen &&
						'text-muted-foreground hover:bg-transparent hover:text-current',
				)}
				onClick={onToggleForm}
			>
				<Plus
					className={cn(
						'transition-transform duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)]',
						formOpen && 'rotate-45',
					)}
				/>
				{formOpen ? 'Cancel' : 'Suggest'}
			</Button>
		</div>
	);
}
